import { v4 as uuidv4 } from 'uuid'

export default class Upsertable {
  constructor() {
    this.created_at = Date.now()
    this.uuid = uuidv4()
    this.synced = false
  }

  setSynced() {
    this.store().setSynced(this.uuid)
  }

  static all() {
    return this.store().all()
  }

  static find(uuid) {
    return this.store().find(uuid)
  }

  // Resolves with the store's response: `{ error: "failed" }` when the record is saved on this
  // device but has not reached the server yet.
  async save() {
    if (typeof this.beforeSave === 'function') {
      this.beforeSave()
    }
    const response = await this.store().save(this)
    if (typeof this.afterSave === 'function') {
      this.afterSave()
    }
    return response
  }

  delete() {
    this.store().delete(this)
  }
}
